module.exports = __webpack_public_path__ + "fonts/LiberationSans-Regular.4acc215d.woff";